<template>
  <div class="q-container q-pe-5 slider-see-more__button-container">
    <a class="q-text-muted q-pe-3 slider-see-more__button" :href="seeMoreUrl" >
      {{ title }}
    </a>
  </div>
</template>
<script setup>
import { computed, defineProps } from 'vue'
import { config } from '@/core/config'
import { useSliderStore } from '@/store/sliderStore'

const sliderStore = useSliderStore()

defineProps(['title'])

const seeMoreUrl  = computed(()=>{
  return config.listingUrl + sliderStore.getOnlyQonizerParameters()
})
</script>
<style scoped>
.slider-see-more__button-container {
  text-align: right !important;
}
</style>